<template>
  <v-row no-gutters justify="center" :class="{ 'table-buttons-move-rotate-box': isActive }">
    <v-col cols="auto">
      <table-button
        name="button-edit-move-rotate"
        v-bind="{ ...$props, ...$attrs, tooltip: isActive ? '' : tooltip, disableCursor: isActive }"
        v-on="mainButtonListeners"
        :buttonSize="isActive ? 'small' : 'default'"
      />
    </v-col>
    <v-col cols="auto" v-if="isActive">
      <table-button
        name="button-edit-move-rotate-accept"
        v-bind="secondaryButtons"
        icon="mdi-check"
        color="success"
        :tooltip="isLoading ? '' : $i18n.t('button.moveRotateGeometryAccept')"
        @click="accept"
      />
      <table-button
        name="button-edit-move-rotate-reject"
        v-bind="secondaryButtons"
        icon="mdi-close"
        color="error"
        :tooltip="isLoading ? '' : $i18n.t('button.moveRotateGeometryReject')"
        @click="toggle"
      />
    </v-col>
  </v-row>
</template>
<script>
import TableButton from '@/components/TableButton';
export default {
  name: 'TableButtonsEditMoveRotate',
  components: { TableButton },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
    },
  },
  computed: {
    mainButtonListeners() {
      return {
        ...(this.isActive ? {} : { click: this.toggle }),
      };
    },
    secondaryButtons() {
      return {
        disabled: this.isLoading,
        fontSize: '19px',
        buttonSize: 'small',
      };
    },
  },
  methods: {
    accept() {
      this.$emit('accept');
    },
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>
<style lang="scss" scoped>
.table-buttons-move-rotate-box {
  border-radius: 5px;
  background-color: map-get($colors, 'primarybackground');
}
</style>
